export default "__VITE_ASSET__CX$HqiKY__"